const DEBUG = process.env.NODE_ENV === "development";
const TRACE_ENABLED = process.env.DEBUG_TRACE === "true";

export const debug = {
  log: (...args: any[]) => {
    if (DEBUG) {
      console.log("[DEBUG]", ...args);
    }
  },
  error: (...args: any[]) => {
    if (DEBUG) {
      console.error("[ERROR]", ...args);
    }
  },
  warn: (...args: any[]) => {
    if (DEBUG) {
      console.warn("[WARN]", ...args);
    }
  },
  info: (...args: any[]) => {
    if (DEBUG) {
      console.info("[INFO]", ...args);
    }
  },
  time: (label: string) => {
    if (DEBUG) {
      console.time(label);
    }
  },
  timeEnd: (label: string) => {
    if (DEBUG) {
      console.timeEnd(label);
    }
  },
  group: (label: string) => {
    if (DEBUG) {
      console.group(label);
    }
  },
  groupEnd: () => {
    if (DEBUG) {
      console.groupEnd();
    }
  },
  trace: (component: string, action: string, data?: any) => {
    if (TRACE_ENABLED) {
      console.group(`[TRACE] ${component}`);
      console.log(`Action: ${action}`);
      if (data) {
        console.log("Data:", data);
      }
      console.groupEnd();
    }
  },
  performance: async (label: string, fn: () => Promise<void>) => {
    if (DEBUG) {
      const uniqueLabel = `${label}-${Date.now()}-${Math.random()
        .toString(36)
        .substr(2, 9)}`;
      // End any existing timer with this label to prevent conflicts
      try {
        console.timeEnd(label);
      } catch (e) {
        // Ignore errors if timer doesn't exist
      }
      console.time(uniqueLabel);
      try {
        await fn();
      } finally {
        try {
          console.timeEnd(uniqueLabel);
        } catch (e) {
          // Ignore errors if timer was already ended
        }
      }
    } else {
      await fn();
    }
  },
  state: (component: string, state: any) => {
    if (DEBUG) {
      console.group(`[STATE] ${component}`);
      console.log("Current State:", state);
      console.groupEnd();
    }
  },
  props: (component: string, props: any) => {
    if (DEBUG) {
      console.group(`[PROPS] ${component}`);
      console.log("Props:", props);
      console.groupEnd();
    }
  },
};
